export enum SidePanelPages {
    DEFAULT = 'default',
    HOMEPAGE = 'home',
    DIRECTSEARCH = 'directSearch',
    PREGUIDEDSEARCH = 'preGuidedSearch',
    GUIDEDSEARCH = 'guidedSearch',
    SURVEY = 'survey',
    INSURANCEPAGE = 'insurancePage'
}

export interface SP_Tag {
    id: string,
    questionId: string,
    text: string,
    nProducts: number
}